import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, ChevronRight } from 'lucide-react';

export default function CTASection() {
  return (
    <section className="section cta-banner">
      <div className="container">
        <div className="cta-banner-content">
          <h2>Complete Industrial & Structural Solutions</h2>
          
          <p>
            From heavy-duty structural fabrication to industrial roofing and custom stainless steel work, 
            Vijay Industry delivers reliable, engineered structures for residential, commercial, and industrial projects.
          </p>
          
          <Link 
            to="/contact" 
            className="btn btn-primary"
            style={{ fontSize: '1.05rem', padding: '0.85rem 2.25rem' }}
          >
            <MessageSquare size={18} />
            Discuss Your Project
            <ChevronRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
